import { connect } from "react-redux";
import * as fromActions from "../../actions";
import Form from "./form";

const mapStateToProps = ({ addInductionMinutesFormReducer }) => ({
	values: addInductionMinutesFormReducer,
});

const mapDispatchToProps = {
	onChange: fromActions.onAddInductionMinutesValueChange,
	onReset: fromActions.onAddInductionMinutesReset,
	onSave: fromActions.onAddInductionMinutesSave,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
